import { Card, Typography } from "antd";
import React, { useEffect, useState } from "react";
import "../Pages/CSS/DonnesBases.css";
import Rubriques from "./Rubriques";
import ConvCollectives from "./ConvCollectives";
import ListCategorie from "./ListCategorie";
import TypePrets from "./TypePrets";

//import React from 'react'
const { Title } = Typography;

const tabListNoTitle = [
  {
    key: "1",
    label: "Liste des Rubriques",
  },
  {
    key: "2",
    label: "Conventions Collectives",
  },
  {
    key: "3",
    label: "Liste des Catégories",
  },
  {
    key: "4",
    label: "Type de Prêts",
  },
 
];

const ParametresPaie = () => {

  const [activeTabKey2, setActiveTabKey2] = useState("1");


  const onTab2Change = (key) => {
    setActiveTabKey2(key);
  };


  return (
      <Card
       
        style={{
          width: "100%",
        }}
        tabList={tabListNoTitle}
        activeTabKey={activeTabKey2}
        
        onTabChange={onTab2Change}
        tabProps={{
          size: "middle",
        }}
      >
        {activeTabKey2 === "1" && <Rubriques/>}
        {activeTabKey2 === "2" && <ConvCollectives />}
        {activeTabKey2 === "3" && <ListCategorie />}
        {activeTabKey2 === "4" && <TypePrets />}
      </Card>
   
  );
};

export default ParametresPaie;
